import React from 'react';
import { createRoot } from 'react-dom/client';
import { getDocument } from '@atlaskit/browser-apis';
import { App } from './ui/App';

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
